import dayjs from "dayjs";

export const browserDetection = () => {
  const ua = navigator?.userAgent;
  let tem, browser, version;

  const browserRegex =
    /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i;

  const ieVersionRegex = /\brv\s*:\s*(\d+)/i;

  const versionRegex = /version\/(\d+)/i;

  const matches = ua.match(browserRegex);

  if (/trident/i.test(matches[1])) {
    tem = ua.match(ieVersionRegex);
    browser = "IE";
    version = tem[1] || "";
  } else if (matches[1] === "Chrome") {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    browser = tem != null ? tem[1].replace("OPR", "Opera") : "Chrome";
    version = tem != null ? tem[2] : "";
  } else {
    browser = matches[1];
    version = matches[2];
    if ((tem = ua.match(versionRegex)) != null) version = tem[1];
  }

  return browser;
};

// Split so no single function carries the whole shape. Each piece keeps its original
// guard structure - the outer truthiness checks and the `text || composed` fallbacks are
// unchanged, so a missing name, dob, qualification or telecom entry is skipped exactly as
// before and the returned keys are identical.
const resolveOfficialPatientName = (names) => {
  let fullName;
  if (names && names.length > 0) {
    const patientNameObj = names.find((name) => name.use === "official");
    if (patientNameObj) {
      fullName =
        patientNameObj.text ||
        `${patientNameObj.given.join(" ")} ${patientNameObj.family}`;
    }
  }
  return fullName;
};

const resolveOfficialPractitionerName = (names) => {
  let fullName;
  if (names && names.length > 0) {
    const practitionerNameObj = names.find((name) => name.use === "official");
    if (practitionerNameObj) {
      fullName =
        practitionerNameObj.text ||
        `${practitionerNameObj.prefix.join(
          " "
        )} ${practitionerNameObj.given.join(" ")} ${
          practitionerNameObj.family
        }`;
    }
  }
  return fullName;
};

const buildPatientFields = (patientObj) => {
  const patient = {};
  if (patientObj?.patientObj) {
    const fullName = resolveOfficialPatientName(patientObj.patientObj.name);
    if (fullName) {
      patient.patient_name = fullName;
    }
    if (patientObj.patientObj.birthDate) {
      patient.patient_dob = dayjs(patientObj.patientObj.birthDate).format("MM/DD/YYYY");
    }
    if (patientObj.patientObj.gender) {
      patient.patient_gender = patientObj.patientObj.gender;
    }
    if (patientObj.patientObj.id) {
      patient.patient_id = patientObj.patientObj.id;
    }
  }
  return patient;
};

const buildPractitionerTelecom = (practitioner, telecom) => {
  if (telecom && telecom.length > 0) {
    const emailObj = telecom.find((entry) => entry.system === "email");
    if (emailObj && emailObj.value) {
      practitioner.practitioner_email = emailObj.value;
    }
    const phoneObj = telecom.find(
      (entry) => entry.system === "phone" && entry.use === "mobile"
    );
    if (phoneObj && phoneObj.value) {
      practitioner.practice_phone_number = phoneObj.value;
    }
  }
};

const buildPractitionerFields = (practitionerData, currentUserSpeciality) => {
  const practitioner = {};
  if (practitionerData) {
    const fullName = resolveOfficialPractitionerName(practitionerData.name);
    if (fullName) {
      practitioner.practitioner_name = fullName;
    }
    if (
      currentUserSpeciality || practitionerData?.qualification?.length>0
    ) {
      practitioner.practitioner_speciality =currentUserSpeciality ||  practitionerData?.qualification?.[0]?.code?.text
      // const qualificationObj = practitionerData.qualification[0];
      // if (qualificationObj.code && qualificationObj.code.text) {
      //   practitioner.practitioner_speciality = qualificationObj.code.text;
      // }
    }
    buildPractitionerTelecom(practitioner, practitionerData.telecom);
  }
  return practitioner;
};

export const getPatientPractitionerObj = (patientObj, practitionerData,currentUserSpeciality) => {
  const patient = buildPatientFields(patientObj);
  const practitioner = buildPractitionerFields(
    practitionerData,
    currentUserSpeciality
  );

  return { patient, practitioner };
};

export const extractPatientAndEncounterIdFromComposition = (payload) => {
  const encounterRef = payload?.encounter?.reference;
  const soapEncounterId = encounterRef?.startsWith("Encounter/") ? encounterRef.split("/")[1] : null;
  const patientRef = payload?.subject?.reference;
  const soapPatientId = patientRef?.startsWith("Patient/") ? patientRef.split("/")[1] : null;
  return { soapPatientId, soapEncounterId };
};

export const hasGenClinicalNotesObservation = (observations) => {
  if (!Array.isArray(observations)) return false;
  return observations.some(
    (obs) =>
      obs?.resource?.code?.coding?.some(
        (coding) => coding?.code === "gen-clinical-notes"
      )
  );
};